import { render, staticRenderFns } from "./DeveloperSchedules.vue?vue&type=template&id=38beaa3f&scoped=true&"
import script from "./DeveloperSchedules.vue?vue&type=script&lang=js&"
export * from "./DeveloperSchedules.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperSchedules.vue?vue&type=style&index=0&id=38beaa3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38beaa3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VContainer,VDialog,VForm,VIcon,VMenu,VRow,VSelect,VSpacer,VSwitch})
